import { PaginationDto } from "../../types/pagination.dto";
import { RoadmapDto } from "../../types/roadmap.dto";

export const GET_ALL_ROADMAPS = "GET_ALL_ROADMAP";
export const GET_ALL_ROADMAPS_ERROR = "GET_ALL_ROADMAP_ERROR";
export const GET_ALL_ROADMAPS_SUCCESS = "GET_ALL_ROADMAP_SUCCESS";
export const RESET_GET_ALL_ROADMAP_DATA = "RESET_GET_ALL_ROADMAP_DATA";
export const GET_ROADMAP = "GET_ROADMAP";
export const GET_ROADMAP_ERROR = "GET_ROADMAP_ERROR";
export const GET_ROADMAP_SUCCESS = "GET_ROADMAP_SUCCESS";
export const RESET_GET_ROADMAP = "RESET_GET_ROADMAP";
export const SET_GET_ROADMAP = "SET_GET_ROADMAP";
export const NEW_ROADMAP = "NEW_ROADMAP";
export const NEW_ROADMAP_ERROR = "NEW_ROADMAP_ERROR";
export const NEW_ROADMAP_SUCCESS = "NEW_ROADMAP_SUCCESS";
export const RESET_NEW_ROADMAP = "RESET_NEW_ROADMAP";
export const UPDATE_ROADMAP = "UPDATE_ROADMAP";
export const UPDATE_ROADMAP_ERROR = "UPDATE_ROADMAP_ERROR";
export const UPDATE_ROADMAP_SUCCESS = "UPDATE_ROADMAP_SUCCESS";
export const RESET_UPDATE_ROADMAP = "RESET_UPDATE_ROADMAP";
export const DELETE_ROADMAP = "DELETE_ROADMAP";
export const DELETE_ROADMAP_ERROR = "DELETE_ROADMAP_ERROR";
export const DELETE_ROADMAP_SUCCESS = "DELETE_ROADMAP_SUCCESS";
export const RESET_DELETE_ROADMAP = "RESET_DELETE_ROADMAP";
export const UPLOAD_MEDIA = "UPLOAD_MEDIA";
export const UPDATE_ROADMAP_LOADING = "UPDATE_ROADMAP_LOADING";
export const ADD_USER_TO_ROADMAP = "ADD_USER_TO_ROADMAP";
export const SHARED_ROADMAP = "SHARED_ROADMAP";
export const UPDATE_MANY_ROADMAP = "UPDATE_MANY_ROADMAP";
export const UPDATE_MANY_ROADMAP_ERROR = "UPDATE_MANY_ROADMAP_ERROR";
export const UPDATE_MANY_ROADMAP_SUCCESS = "UPDATE_MANY_ROADMAP_SUCCESS";
export const RESET_UPDATE_MANY_ROADMAP = "RESET_UPDATE_MANY_ROADMAP";
export interface SharedRoadmap {
  type: typeof SHARED_ROADMAP;
  payload: any;
}

export interface UpdateManyRoadmap {
  type: typeof UPDATE_MANY_ROADMAP;
  payload: any;
}

export interface UpdateManyRoadmapSuccess {
  type: typeof UPDATE_MANY_ROADMAP_SUCCESS;
  payload: RoadmapDto[];
}

export interface UpdateManyRoadmapError {
  type: typeof UPDATE_MANY_ROADMAP_ERROR;
  payload: boolean | string;
}

export interface ResetUpdateManyRoadmap {
  type: typeof RESET_UPDATE_MANY_ROADMAP;
  payload: null;
}

export interface GetAllRoadmaps {
  type: typeof GET_ALL_ROADMAPS;
  payload: PaginationDto;
}

export interface ResetGetAllRoadmapData {
  type: typeof RESET_GET_ALL_ROADMAP_DATA;
  payload: null;
}

export interface GetAllRoadmapsSuccess {
  type: typeof GET_ALL_ROADMAPS_SUCCESS;
  payload: RoadmapDto[];
}

export interface SetGetRoadmap {
  type: typeof SET_GET_ROADMAP;
  payload: RoadmapDto | null;
}

export interface GetAllRoadmapsError {
  type: typeof GET_ALL_ROADMAPS_ERROR;
  payload: boolean | string;
}

export interface AddUserToRoadmap {
  type: typeof ADD_USER_TO_ROADMAP;
  payload: any;
}

export interface GetRoadmap {
  type: typeof GET_ROADMAP;
  payload: { id: string };
}

export interface GetRoadmapSuccess {
  type: typeof GET_ROADMAP_SUCCESS;
  payload: RoadmapDto;
}

export interface GetRoadmapError {
  type: typeof GET_ROADMAP_ERROR;
  payload: boolean | string;
}

export interface NewRoadmap {
  type: typeof NEW_ROADMAP;
  payload: RoadmapDto;
}

export interface NewRoadmapSuccess {
  type: typeof NEW_ROADMAP_SUCCESS;
  payload: RoadmapDto;
}

export interface ResetGetRoadmap {
  type: typeof RESET_GET_ROADMAP;
  payload: null;
}

export interface NewRoadmapError {
  type: typeof NEW_ROADMAP_ERROR;
  payload: boolean | string;
}

export interface UploadMedia {
  type: typeof UPLOAD_MEDIA;
  payload: any;
}

export interface ResetNewRoadmap {
  type: typeof RESET_NEW_ROADMAP;
  payload: null;
}

export interface UpdateRoadmap {
  type: typeof UPDATE_ROADMAP;
  payload: any;
}

export interface UpdateRoadmapLoading {
  type: typeof UPDATE_ROADMAP_LOADING;
  payload: RoadmapDto;
}

export interface UpdateRoadmapSuccess {
  type: typeof UPDATE_ROADMAP_SUCCESS;
  payload: RoadmapDto;
}

export interface UpdateRoadmapError {
  type: typeof UPDATE_ROADMAP_ERROR;
  payload: boolean | string;
}

export interface ResetUpdateRoadmap {
  type: typeof RESET_UPDATE_ROADMAP;
  payload: null;
}

export interface DeleteRoadmap {
  type: typeof DELETE_ROADMAP;
  payload: { _id: string };
}

export interface DeleteRoadmapSuccess {
  type: typeof DELETE_ROADMAP_SUCCESS;
  payload: null;
}

export interface DeleteRoadmapError {
  type: typeof DELETE_ROADMAP_ERROR;
  payload: boolean | string;
}

export interface ResetDeleteRoadmap {
  type: typeof RESET_DELETE_ROADMAP;
  payload: null;
}

export interface State {
  all: {
    data: RoadmapDto[] | null;
    states: {
      loading: boolean;
      success: boolean;
      error: boolean | string;
    };
  };
  updateMany: {
    data: null | RoadmapDto[];
    states: {
      loading: boolean;
      success: boolean;
      error: boolean | string;
    };
  };
  roadmap: {
    data: RoadmapDto | null;
    states: {
      loading: boolean;
      success: boolean;
      error: boolean | string;
    };
  };
  new: {
    data: RoadmapDto | null;
    states: {
      loading: boolean;
      success: boolean;
      error: boolean | string;
    };
  };
  delete: {
    states: {
      loading: boolean;
      success: boolean;
      error: boolean | string;
    };
  };
  update: {
    data: null | RoadmapDto;
    states: {
      loading: boolean;
      success: boolean;
      error: boolean | string;
    };
  };
}

export const initialState: State = {
  all: {
    data: null,
    states: {
      loading: false,
      success: false,
      error: false,
    },
  },
  roadmap: {
    data: null,
    states: {
      loading: false,
      success: false,
      error: false,
    },
  },
  updateMany: {
    data: null,
    states: {
      loading: false,
      success: false,
      error: false,
    },
  },
  new: {
    data: null,
    states: {
      loading: false,
      success: false,
      error: false,
    },
  },
  delete: {
    states: {
      loading: false,
      success: false,
      error: false,
    },
  },
  update: {
    data: null,
    states: {
      loading: false,
      success: false,
      error: false,
    },
  },
};

export type Actions =
  | GetAllRoadmaps
  | GetAllRoadmapsSuccess
  | GetAllRoadmapsError
  | ResetGetAllRoadmapData
  | GetRoadmap
  | GetRoadmapSuccess
  | GetRoadmapError
  | NewRoadmap
  | NewRoadmapSuccess
  | NewRoadmapError
  | ResetNewRoadmap
  | UpdateRoadmap
  | UpdateRoadmapSuccess
  | UpdateRoadmapError
  | ResetUpdateRoadmap
  | DeleteRoadmap
  | DeleteRoadmapSuccess
  | DeleteRoadmapError
  | ResetDeleteRoadmap
  | UploadMedia
  | UpdateRoadmapLoading
  | ResetGetRoadmap
  | AddUserToRoadmap
  | SharedRoadmap
  | SetGetRoadmap
  | UpdateManyRoadmap
  | UpdateManyRoadmapSuccess
  | UpdateManyRoadmapError
  | ResetUpdateManyRoadmap;
